import { useEffect, useState } from "react";

interface StreamingDisplayState {
  displayedReasoning: string;
}

export function useStreamingDisplay(
  reasoningText: string | undefined,
  typewriterSpeed = 10,
): StreamingDisplayState {
  const [displayedReasoning, setDisplayedReasoning] = useState("");
  // Typewriter effect for reasoning
  useEffect(() => {
    if (!reasoningText) return;

    if (displayedReasoning.length < reasoningText.length) {
      const timer = setTimeout(() => {
        setDisplayedReasoning(
          reasoningText.slice(0, displayedReasoning.length + 1),
        );
      }, typewriterSpeed);
      return () => clearTimeout(timer);
    } else {
      setDisplayedReasoning(reasoningText);
    }
  }, [reasoningText, displayedReasoning, typewriterSpeed]);

  return { displayedReasoning };
}
